// Maps raw AI-provider / backend error messages to user-friendly text.
//
// When the AI model runs out of balance or hits a rate/quota/capacity limit the
// backend surfaces technical strings like "400 Billing hard limit has been
// reached" or "429 Too many requests". Those must never reach end users — we
// show a calm "try again later" message instead.

// Matches provider/capacity failures that are NOT the user's fault and are
// transient-ish (retry later). Kept deliberately broad but specific enough to
// avoid masking genuine input errors (e.g. "image required").
const AI_CAPACITY_PATTERN =
    /billing|hard limit|quota|insufficient|balance|credit|rate.?limit|\b429\b|\b402\b|overloaded|capacity|too many requests|exceeded|temporarily unavailable|service unavailable|\b503\b/i;

export function isAiCapacityError(message) {
    const m = typeof message === 'string' ? message : (message?.message || '');
    return AI_CAPACITY_PATTERN.test(m);
}

// Returns the message to display: a friendly capacity message for provider/limit
// failures, otherwise the original message (or a caller-supplied fallback).
export function friendlyAiErrorMessage(rawMessage, { busyMessage, fallback } = {}) {
    const m = typeof rawMessage === 'string' ? rawMessage : (rawMessage?.message || '');
    if (isAiCapacityError(m)) return busyMessage;
    return m || fallback || busyMessage;
}
